import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertTriangle, FiInfo, FiCheckCircle } from 'react-icons/fi';
import { motion } from 'framer-motion';

const Insights = ({ tdee, goalCalories, goalType, activity, weightLbs }) => {
  const deficit = tdee - goalCalories;
  const warnings = [];

  // Low Calorie Warning
  if (goalCalories < 1600 && goalType.includes('cut')) {
    warnings.push({
      type: 'warning',
      text: 'Your target calories are below 1600. This may lead to metabolic adaptation. Consider a higher activity level or a slower cut.',
      icon: FiAlertTriangle
    });
  }

  // Aggressive Cut Warning
  if (deficit > (tdee * 0.25) && goalType.includes('cut')) {
    warnings.push({
      type: 'danger',
      text: 'You are targeting a deficit greater than 25%. This increases the risk of muscle loss and is hard to sustain.',
      icon: FiAlertTriangle
    });
  }

  // Bulk Warning
  if (goalCalories > tdee + 500 && goalType.includes('bulk')) {
    warnings.push({
      type: 'info',
      text: 'A surplus over 500 calories/day often results in excessive fat gain alongside muscle.',
      icon: FiInfo
    });
  }

  // Activity Mismatch (Heuristic)
  if (activity === 'athlete' && weightLbs < 120) {
    warnings.push({
      type: 'info',
      text: 'Selected "Athlete" activity with low body weight. Ensure this accurately reflects your training volume to avoid overestimating TDEE.',
      icon: FiInfo
    });
  }

  if (warnings.length === 0) return null;

  return (
    <div className="space-y-4 mt-8">
      <h3 className="text-xl font-bold text-gray-900 dark:text-white">Intelligent Insights</h3>
      {warnings.map((w, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.1 }}
          className={`p-4 rounded-lg flex items-start gap-3 border-l-4 ${
            w.type === 'danger' ? 'bg-red-50 dark:bg-red-900/20 border-red-500 text-red-700 dark:text-red-200' :
            w.type === 'warning' ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-500 text-amber-700 dark:text-amber-200' :
            'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-700 dark:text-blue-200'
          }`}
        >
          <SafeIcon icon={w.icon} className="mt-1 flex-shrink-0 w-5 h-5" />
          <p className="text-sm leading-relaxed">{w.text}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default Insights;